import { COLLECT_COMPAT } from '@/api/apiModules'

import dictionary from '@/utils/dictionary'
export default {
  viewType: 'table',
  module: COLLECT_COMPAT,
  params: null,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  refreshInterval: false,
  // relationSearch: true,
  allowStatus: {},
  toolbar: {
    searchWidth: 300,
    searchPlaceholder: '软件/外设名称',
    searchFieldNameArr: ['compatibleObjName'],
    tips: {
      label:
        '注：本功能可以查询到全国售前或售后人员在项目实施中的兼容性测试结果数据，包括兼容性信息及测试结果（仅供参考）',
      type: 'info'
    }
  },

  view: {
    columns: [
      {
        props: {
          label: '软件/外设名称',
          prop: 'compatibleObjName'
        }
      },
      {
        props: {
          label: '软件版本/设备类型',
          prop: 'compatibleObjVal',
          width: 280
        }
      },
      {
        props: {
          label: '类型',
          prop: 'compatibleObjType',
          sortField: 'compatibleObjType',
          width: 120
        },
        filter: true,
        dictionaryPath: 'collectType',
        dataType: 'custom',
        custom: function(data, h) {
          if (!data) {
            return
          }
          if (dictionary['collectType'][data.compatibleObjType].type) {
            const renderItem = [
              <el-tag type={dictionary['collectType'][data.compatibleObjType].type}>
                {dictionary['collectType'][data.compatibleObjType].label}
              </el-tag>
            ]
            return renderItem
          } else {
            return []
          }
        }
      },
      {
        props: {
          label: '兼容性数量',
          prop: 'compatibleNum',
          width: 100
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 180
        },
        dataType: 'date'
      },
      {
        //操作
        props: {
          showBtnNum: '1'
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '查看详情',
        command: 'showCompatibleDetail',
        name: 'showCompatibleDetail'
      }
    ]
  }
}
